import React from 'react';
import styled from 'styled-components';

const AlertInfoIcon = () => {
return(
    <Container>
        <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.0002 4.19914C7.61539 4.19914 3.25016 8.56436 3.25016 13.9491C3.25016 19.3339 7.61539 23.6991 13.0002 23.6991C18.3849 23.6991 22.7502 19.3339 22.7502 13.9491C22.7502 8.56436 18.3849 4.19914 13.0002 4.19914ZM1.0835 13.9491C1.0835 7.36774 6.41877 2.03247 13.0002 2.03247C19.5816 2.03247 24.9168 7.36774 24.9168 13.9491C24.9168 20.5305 19.5816 25.8658 13.0002 25.8658C6.41877 25.8658 1.0835 20.5305 1.0835 13.9491Z"
                  fill="#444343"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.9998 12.866C13.5981 12.866 14.0832 13.351 14.0832 13.9493V18.2826C14.0832 18.8809 13.5981 19.366 12.9998 19.366C12.4015 19.366 11.9165 18.8809 11.9165 18.2826V13.9493C11.9165 13.351 12.4015 12.866 12.9998 12.866Z"
                  fill="#444343"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M11.9165 9.6158C11.9165 9.0175 12.4015 8.53247 12.9998 8.53247H13.0107C13.609 8.53247 14.094 9.0175 14.094 9.6158C14.094 10.2141 13.609 10.6991 13.0107 10.6991H12.9998C12.4015 10.6991 11.9165 10.2141 11.9165 9.6158Z"
                  fill="#444343"/>
        </svg>
    </Container>
)

}
export default AlertInfoIcon;

const Container = styled.div`

`;